// lib
import { Subject } from 'rxjs';

// elvispos
// import { BaseWebSocket } from '../../base/websocket';
import { SAMMessage } from '../interfaces/sam-message';
import { Logger } from 'ngx-elvis-ds';
import { BaseWebSocket } from 'src/app/base/websocket';
import { GUIHelperService } from 'src/app/gui-helper.service';

export class SAM extends BaseWebSocket {

  messages: Subject<any> = new Subject();

  constructor(
    public guiHelperSvc: GUIHelperService
  ) {
    super();
  }

  onSend(message: any, source = '') {
    try {
      message = this.initGUIMessage(message, source);
      const stringMessage: string = JSON.stringify(message);

      this.socket.send(stringMessage);

      try {
        this.guiHelperSvc.onWriteLog(
          'info',
          `${message.Source} >> ${message.Destination} : ${stringMessage}`
        )
      } catch (error) { }

      this.events.next('send');
    } catch (error) {
      this.events.next('send::error');
      Logger.error('SAM::WebSocket::onSend', error);
    }
  }

  onError(err: any) {
    this.events.next('error');
    Logger.error('SAM::WebSocket::onError', err);
  }

  onMessage(event: any) {
    const message = JSON.parse(event.data) as SAMMessage;
    try {
      this.guiHelperSvc.onWriteLog(
        'info',
        `${message.Source} >> ${message.Destination} : ${JSON.stringify(message)}`
      )
    } catch (error) { }
    this.messages.next(message);
  }

  onOpen(event: any) {
    this.events.next('open');
    Logger.log('SAM::onOpen', event);
  }

  onClose(event: any) {
    this.events.next('close');
    Logger.log('SAM::onClose', event);
  }

  // private

  private initGUIMessage(message, source) {
    message.Source = 'GUI';
    message.Destination = source || 'SAM';
    message.Object = '';
    message.Method = '';
    message.Sync = 0;

    return message;
  }
}
